/**
 * Replace placeholder tokens (e.g., {name}) in a template string.
 *
 * @param {string} template - Template string containing {placeholders}.
 * @param {Record<string, string | number>} [params] - Values to interpolate.
 * @returns {string}
 */
export function formatMessage(template, params = {}) {
  if (!template || typeof template !== 'string') {
    return template ?? '';
  }

  return Object.entries(params).reduce(
    (result, [key, value]) =>
      result.replace(new RegExp(`\\{${key}\\}`, 'g'), value != null ? String(value) : ''),
    template
  );
}
